import { ProfileFormData } from "../profile.types";
import { apiRequest } from "@core/services/api/apiRequest";

export type UpdateUserProfileArgs = {
  data: ProfileFormData & {
    media_id?: string;
    resume_media_id?: string;
    isTextNotificationsEnabled?: boolean;
  };
  role: string;
};

export type UpdateUserProfileResponse = {
  user_data: Record<string, unknown>;
};

/**
 * Updates user profile via API
 * Converts camelCase form data to snake_case API payload
 */
export async function updateUserProfile({
  data,
  role,
}: UpdateUserProfileArgs): Promise<UpdateUserProfileResponse> {
  const {
    firstName,
    lastName,
    isEmailNotificationsEnabled,
    isTextNotificationsEnabled,
    photo,
    cv,
    ...rest
  } = data;

  const payload: Record<string, unknown> = {
    first_name: firstName,
    last_name: lastName,
    is_email_notifications_enabled: isEmailNotificationsEnabled,
    role,
    ...rest,
  };

  // Add text notifications if provided
  if (isTextNotificationsEnabled !== undefined) {
    payload.is_text_notifications_enabled = isTextNotificationsEnabled;
  }

  // Remove photo and cv from payload - they're handled separately via media_id
  delete (payload as Record<string, unknown>).photo;
  delete (payload as Record<string, unknown>).cv;

  const response = (await apiRequest(
    `/profile/`,
    "POST",
    payload
  )) as UpdateUserProfileResponse;

  return response;
}

export default updateUserProfile;
